/**
 * initExtractChars
 */
const initExtractChars = () => {
  const activeLangTxt = document.querySelector(
    ".gtranslate_wrapper > .gt_switcher-popup > span:first-of-type"
  );
  const langUrls = document.querySelectorAll(".gt_languages .glink");

  activeLangTxt.innerText = activeLangTxt.innerText.substring(0, 2);

  // Refresh the page when clicking any of the languages in the popup to force the language string to update
  langUrls.forEach((url) => {
    url.addEventListener("click", () => {
      const languageCode = url.dataset.gtLang;
      const newActiveTxt = document.querySelector(
        ".gtranslate_wrapper > .gt_switcher-popup > span:first-of-type"
      );
      newActiveTxt.innerText = newActiveTxt.innerText.substring(0, 2);
    });
  });
};

export default initExtractChars;
